import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import MainButton from "../../../../shared/button/MainButton";
import styles from "./WarningModal.module.scss";
import closeIcon from "../../../../../assets/images/referal/Close Icon.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

interface modalProps {
  warningModalOpen: boolean;
  setWarningModalOpen: (value: boolean) => void;
  content: any;
}

const WarningModal = ({
  warningModalOpen,
  setWarningModalOpen,
  content,
}: modalProps) => {
  const navigate = useNavigate();
  const { data } = useSelector((state: RootState) => state.translationData);

  return (
    <GlobalModalComponent
      isOpen={warningModalOpen}
      onClose={() => setWarningModalOpen(false)}
    >
      <div className={styles.warningModal}>
        <div
          className={styles.closeButton}
          onClick={() => setWarningModalOpen(false)}
        >
          <img src={closeIcon} alt="" />
        </div>
        <h3 className={styles.title}>{content.title}</h3>
        <div className={styles.warningMessageWrap}>
          <p className={styles.warningMessage}>{content.content}</p>
          <p className={styles.priceMessage}>
            {content.balance} {content.currency}
          </p>
          <p className={styles.priceMessage}>
            {content.amount_paid} {content.currency}
          </p>
        </div>
        <div
          className={content.balance ? styles.btnWrap : styles.no_balance_info}
        >
          {content.balance && (
            <MainButton
              text={data?.balance_topup}
              onClick={() => {
                navigate("/account/my-balance", {
                  state: { debt: content.debt },
                });
                localStorage.setItem("lastBalanceAmount", content.debt);
              }}
            />
          )}
          <MainButton
            text={data?.close}
            onClick={() => setWarningModalOpen(false)}
            className={styles.close_button}
          />
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default WarningModal;
